import { getProjectName } from 'lib/get-project-name'
import React, { FC } from 'react'
import styled from 'styled-components'
import { SkeletonBlock } from 'ui/skeleton-block'

export type Props = {
  ratio: {
    x: number
    y: number
  }
}

const SpecSkeleton = () => (
  <Specification>
    <SkeletonBlock />
  </Specification>
)

export const SkeletonCard: FC<Props> = ({ ratio }) => {
  return (
    <Container>
      <Box>
        <ImageWrapper ratio={ratio}>
          <Image>
            <SkeletonBlock />
          </Image>
        </ImageWrapper>
        <Content>
          <Title>
            <SkeletonBlock />
          </Title>
          <SubTitle>
            <SkeletonBlock />
          </SubTitle>
          <Specifications>
            <SpecSkeleton />
            <SpecSkeleton />
            <SpecSkeleton />
          </Specifications>
          <Status>
            <SkeletonBlock />
          </Status>
          <Prices>
            <SkeletonBlock />
          </Prices>
          <Dealer>
            <SkeletonBlock />
          </Dealer>
        </Content>
      </Box>
    </Container>
  )
}

const Container = styled.section`
  height: 100%;
  width: 100%;
  background: ${getProjectName() === 'generic_v2' && '#2c2c2c'};

  &:last-of-type {
    margin-right: 0;
  }
`

const Box = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.palette.white};
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  text-decoration: none;
  transition: box-shadow 0.2s;
  background: ${getProjectName() === 'generic_v2' && '#2c2c2c'};

  &:hover {
    box-shadow: 0 0.2rem 1rem 0 rgba(0, 0, 0, 0.1);
  }
`

const ImageWrapper = styled.div<Props>`
  margin-bottom: ${({ theme }) => theme.spacing[2]};
  width: 100%;
  background: ${getProjectName() === 'generic_v2' && '#2c2c2c'};

  padding-top: ${({ ratio }) => `calc(${ratio.y / ratio.x} * 100%)`};
  position: relative;
`

const Image = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  margin-bottom: ${({ theme }) => theme.spacing[2]};
  width: 100%;
  height: 100%;
  background: ${getProjectName() === 'generic_v2' && '#2c2c2c'};

  & div {
    background: ${getProjectName() === 'generic_v2' && '#2c2c2c'};
  }
`

const Content = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;

  padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[4]} ${theme.spacing[3]}`};
  ${({ theme }) => theme.textStyles.p3};

  & div {
    background: ${getProjectName() === 'generic_v2' && '#1f1f1f !important'};
  }
`

const Title = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing[2]};
  width: 50%;
  height: ${({ theme }) => theme.spacing[8]};
`

const SubTitle = styled.div`
  width: 100%;
  height: ${({ theme }) => theme.spacing[4]};
  margin-bottom: ${({ theme }) => theme.spacing[4]};
  margin-top: auto;
`

const Specifications = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing[5]};
`

const Specification = styled.div`
  width: 50%;
  height: ${({ theme }) => theme.spacing[4]};

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing[2]};
  }
`

const Status = styled.div`
  width: 100%;
  height: ${({ theme }) => theme.spacing[4]};
  margin-bottom: 0.8em;
`

const Prices = styled.div`
  width: 100%;
  height: ${({ theme }) => theme.spacing[8]};
  margin-bottom: ${({ theme }) => theme.spacing[2]};
`

const Dealer = styled.div`
  width: 100%;
  height: ${({ theme }) => theme.spacing[4]};
`
